import * as Yup from 'yup';

export const createEmployeeFormSchema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required'),
  userName: Yup.string().required('Username is required'),
  // userRoles: Yup.object()
  //   .shape({ roleID: Yup.string().required('Role is required') })
  //   .nonNullable()
  //   .required('Role is required'),

  // multy select
  userRoles: Yup.array()
    .nullable() // Allows undefined or null initially
    .required('Role is required') // Throws an error if userRoles is undefined
    .min(1, 'Role is required'), // Ensures the array has at least one selected role

  userPassword: Yup.string()
    .required('Password is required')
    .matches(/^(?=.*[A-Z])/, 'Password must contain at least one uppercase letter') // Enforces uppercase
    .matches(/^(?=.*[@$!%*?&])/, 'Password must contain at least one special character')
    .min(16, 'Password must be at least 16 characters long'),
  confirmPassword: Yup.string()
    .required('Confirm Password is required')
    .oneOf([Yup.ref('userPassword'), ''], 'Passwords must match'),
  // userPassword: Yup.string(), // No required validation
  // confirmPassword: Yup.string().oneOf([Yup.ref('userPassword'), undefined], 'Passwords must match'),
  // userPassword: Yup.string().when('userRoles', (userRoles, schema) => {
  //   if (Array.isArray(userRoles)) {
  //     const hasInspectorRole = userRoles?.some((role) => role?.roleName === 'Inspector');
  //     if (!hasInspectorRole) {
  //       return schema.required('Password is required');
  //     }
  //   }
  //   return schema;
  // }),
  // confirmPassword: Yup.string().when('userRoles', (userRoles, schema) => {
  //   const hasInspectorRole = Array.isArray(userRoles) ? userRoles.some((role) => role?.roleName === 'Inspector') : false;

  //   // Always require confirmPassword unless the role is Inspector
  //   if (!hasInspectorRole) {
  //     return schema
  //       .required('Confirm Password is required') // Always required
  //       .oneOf([Yup.ref('userPassword')], 'Passwords must match'); // Match validation
  //   }

  //   return schema.nullable(); // If the role is Inspector, confirmPassword can be nullable
  // }),
  email: Yup.string().email('Invalid email').required('Contact Email is required'),
  fastFieldEmailID: Yup.string().email('Invalid email').notRequired(),
  mobile: Yup.string()
    .matches(/^[0-9]+$/, { excludeEmptyString: true, message: 'Invalid phone number' })
    .required('Contact phone number is required'),
});
